import { writable } from 'svelte/store';
const store = writable({

    user: {
        id: null,
        username: null,
        display_name: null,
    },

    quotations: [],
});
export default store;


export function update_user(ok, id, username, display_name){
    store.update(data => {
        data._in = ok;
        data.user.id = ok ? id :null;
        data.user.username = ok ? username :null;
        data.user.display_name = ok ? display_name :null;
        return data;
    });
}